const questionImageMap = {
  "welcome_skin_desktop":"https://cdn.shopify.com/s/files/1/0642/1299/2252/files/GlowScan-Skin_Analysis-Quiz-11-Desktop.png",
  "welcome_skin_mobile":"https://cdn.shopify.com/s/files/1/0642/1299/2252/files/GlowScan-Skin_Analysis-Quiz-11-Mobile.png?v=1745831262",
  "welcome_hair_desktop":"https://cdn.shopify.com/s/files/1/0642/1299/2252/files/GlowScan-Hair_Analysis-Quiz-11-Desktop.png?v=1748846376",
  "welcome_hair_mobile":"https://cdn.shopify.com/s/files/1/0642/1299/2252/files/GlowScan-Hair_Analysis-Quiz-11-Desktop.png?v=1748846376"
};

let loaderHidden = false;
let element_main_container = null;
let iframeElement = null;

let sideImageElement;

let elementImageContainer = document.getElementById("tangent-image-container");
let pageHandle = document.getElementById("tangent-shop-handle");
let elementImageContainerVisible = true;
// let elementLoaderContainer = document.getElementById("loader-container");

window.addEventListener('load', (event) => {
  
  element_main_container = document.getElementById("main-tangent-container");
  iframeElement = document.getElementById("tangent-block-quiz-iframe");
  setSideImageElement();
  elementImageContainer = document.getElementById("tangent-image-container");
  
  // POST MESSAGE ON WINDOW ONLOAD
  setTimeout(function() {
    var iframe = document.getElementById("tangent-block-quiz-iframe");
    postMessageToIFrame(iframe);
  }, 3000);
});

setSideImageElement();

function setSideImageElement(){
  if(detectMob()){
    sideImageElement = document.getElementById("mobile-tangent-quiz-container-image");
  }
  else{
    sideImageElement = document.getElementById("desktop-tangent-quiz-container-image");
  }
}

function detectMob(){
    const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
    ];
    
    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
}

iframeElement = document.getElementById("tangent-block-quiz-iframe");

// POST MESSAGE ON IFRAME ONLOAD
iframeElement.addEventListener("load", function() {
  postMessageToIFrame(iframeElement);
  setQuizLoaderHidden();
});


function setQuizLoaderHidden(){
  const loader = document.getElementById("quiz-loader");
  if(loader && !loaderHidden){
    loader.style.display="none";
    loaderHidden = true;
  }
}
function postMessageToIFrame(iframe){
  var iframe_window = iframe.contentWindow;
  // URL OF IFRAME LOAD CLIENT
  var url = window.location.href;

  // POST MESSAGE WITH URL
  var parent_url_params = encodeURIComponent(url);
  var parent_load_url = "tangent_client_url:"+parent_url_params;
  iframe_window.postMessage(parent_load_url, iframe.src);

  // POST MESSAGE WITH COOKIES
  var cookie_setting = "tangent_cookie:"+document.cookie;
  iframe_window.postMessage(cookie_setting, iframe.src);
}

function bindEvent(element, eventName, eventHandler) {
  if (element.addEventListener){
    element.addEventListener(eventName, eventHandler, false);
  } else if (element.attachEvent) {
    element.attachEvent('on' + eventName, eventHandler);
  }
}

function isJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

// Listen to message from child window
bindEvent(window, 'message', function (e) {
  handleIncomingMessage(e.data);
});

function handleIncomingMessage(message) {
  var isValidJson = isJsonString(message);
  if (isValidJson) {
    // hideElement(elementLoaderContainer);
    var parsedMessage = JSON.parse(message);  // Parsing the incoming message
    if (parsedMessage.quiz_type == "inline") {
      if (!iframeElement) return; // Ensure iframe exists before manipulating

      switch (parsedMessage.type) {
        case 'page':
          if (parsedMessage.key === 'scrollTop' && detectMob()) {
            scrollToIframe(iframeElement);
          }

          if (parsedMessage.key === 'iframe-height' && parsedMessage.value !== undefined) {
            setIframeHeight(iframeElement, parsedMessage.value);
          }

          if (parsedMessage.key === 'screenId') {
            updateScreenContent(parsedMessage.screen_id);
          }
          break;

        case 'number':
          setIframeHeight(iframeElement, parseInt(message, 10));
          break;

        default:
          break;
      }
    }
  }
}

// Function to scroll to the iframe position
function scrollToIframe(iframeElement) {
  var headerOffset = 300;
  var iframePosition = iframeElement.getBoundingClientRect().top;
  var scrollToPosition = iframePosition + window.pageYOffset - headerOffset;
  window.scrollTo({
    top: scrollToPosition,
    behavior: "smooth"
  });
}

// Function to adjust the iframe height
function setIframeHeight(iframeElement, newHeight) {
  var currentHeight = parseInt(window.getComputedStyle(iframeElement).height, 10);
  if (newHeight !== currentHeight) {
    iframeElement.style.cssText = `min-height: ${newHeight}px; width: 100%; display: inline;`;
  }
}

// Function to update screen image and handle banner visibility
function updateScreenContent(screenId) {
;  setQuizLoaderHidden();
  if (screenId === 'selfie' || screenId === 'camera' || screenId === 'selfie-result' || screenId==='67ee5d8ba5f62bd5bacd1242' || screenId==="6822ece11593c96d37cc5506" || screenId==='summary') {
    hideElement(elementImageContainer);
    elementImageContainerVisible = false;
    setBorderClass(true);
  }
  else{
    setBorderClass(false);
    if(!elementImageContainerVisible){
      showElement(elementImageContainer);
      elementImageContainerVisible = true;
    }
    
    if(pageHandle.innerHTML=='glowscan-skin-analysis-quiz'){
     screenId = screenId+'_skin';
    }
    else{
      screenId = screenId+'_hair';
    }
    screenId = screenId + (detectMob() ? "_mobile" : "_desktop");
    console.log("screenid",screenId);
    
    if (questionImageMap[screenId] != null && sideImageElement.src != questionImageMap[screenId]) {
      sideImageElement.setAttribute("src", "");
      sideImageElement.setAttribute("src", questionImageMap[screenId]);
      showElement(sideImageElement);
    }  
  }
}

function setBorderClass(status){
  if(status){
    iframeElement.classList.add("all-border");
  }
  else{
    iframeElement.classList.remove("all-border");
  }
}

function showElement(element){
    element.classList.remove("tangent-hidden");
    element.classList.add("tangent-visible");
}

function hideElement(element){
    element.classList.remove("tangent-visible");
    element.classList.add("tangent-hidden");
}